export default {
  PROFILE_HEADER: 'ProfileHeader',
  FREE_SHIPPING_BAR: 'FreeShippingBar',
  BOTTOM_SHEET_IFRAME: 'BottomSheetIframe',
};
